var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyticsWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2110_909)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M4.0625 17.2656V5.07812C4.0625 2.83446 5.88133 1.01562 8.125 1.01562H5.07812C2.83446 1.01562 1.01562 2.83446 1.01562 5.07812V17.2656C1.01562 19.5093 2.83446 21.3281 5.07812 21.3281H8.125C5.88133 21.3281 4.0625 19.5093 4.0625 17.2656Z",
    fill: "url(#paint0_linear_2110_909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.90625 15.2344H19.0938M8.9375 11.1719V15.2344M13 9.14062V15.2344M17.0625 7.10938V15.2344",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 24.9844V21.3281H5.07812C2.83446 21.3281 1.01562 19.5093 1.01562 17.2656V5.07812C1.01562 2.83446 2.83446 1.01562 5.07812 1.01562H20.9219C23.1655 1.01562 24.9844 2.83446 24.9844 5.07812V17.2656C24.9844 19.5093 23.1655 21.3281 20.9219 21.3281H17.0625M8.9375 24.9844H17.0625",
    stroke: "url(#paint1_linear_2110_909)",
    strokeWidth: 2.04286,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2110_909",
    x1: 1.01562,
    y1: 1.01562,
    x2: 14.7287,
    y2: 7.62325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2110_909",
    x1: 1.44445,
    y1: -1.67943,
    x2: 29.1602,
    y2: 24.3093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2110_909"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsWhite);
export default __webpack_public_path__ + "static/media/analyticsWhite.598c659aec9e3fa29a71bb3fa9b06f5f.svg";
export { ForwardRef as ReactComponent };